export const normalizeStorageUrl = url => {
  if (!url) return '';
  return url.replace('://0.0.0.0', '://localhost');
};

export const normalizeAgentAvatars = agents =>
  (agents || []).map(agent => ({
    ...agent,
    avatar_url: normalizeStorageUrl(agent.avatar_url),
  }));
